import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/ldas`;

/** LDAS 카테고리는 건수가 적어 한 번에 넉넉히 조회 (백엔드 list page/size) */
const LDAS_CATEGORY_LIST_PAGE_SIZE = 200;

// 제품 목록 조회 (query?, page, size — 서버 페이지네이션)
const readLdasProductList = async ({
  query: searchQuery = "",
  page = 0,
  size = 10,
} = {}) => {
  const params = { page, size };
  const q = (searchQuery || "").trim();
  if (q) {
    params.query = q;
  }
  const { data } = await axios.get(`${baseUrl}/product/list`, { params });
  return data;
};

// 제품 등록
const createLdasProduct = async (dto) => {
  const { data } = await axios.post(`${baseUrl}/product`, dto);
  return data;
};

// 제품 상세 조회
const readLdasProductDetail = async (id) => {
  const { data } = await axios.get(`${baseUrl}/product/${id}`);
  return data;
};

// 제품 수정
const updateLdasProduct = async (id, dto) => {
  const { data } = await axios.put(`${baseUrl}/product/${id}`, dto);
  return data;
};

// 제품 삭제
const deleteLdasProduct = async (id) => {
  const { data } = await axios.delete(`${baseUrl}/product/${id}`);
  return data;
};

/**
 *
 * 카테고리 api
 */

// 전체 카테고리 목록 조회 (page/size로 한 번에 전부 — UI 페이지네이션 없음)
const readLdasCategoryList = async () => {
  const { data } = await axios.get(`${baseUrl}/category/list`, {
    params: { page: 0, size: LDAS_CATEGORY_LIST_PAGE_SIZE },
  });
  const r = data?.result;
  if (r && Array.isArray(r.content)) {
    return { ...data, result: r.content };
  }
  return data;
};

// 제품별 카테고리 목록 조회
const readLdasCategoryListByProduct = async (productId) => {
  const { data } = await axios.get(`${baseUrl}/category/list/${productId}`);
  return data;
};

// 카테고리 등록
const createLdasCategory = async (dto) => {
  const { data } = await axios.post(`${baseUrl}/category`, dto);
  return data;
};

// 카테고리 수정
const updateLdasCategory = async (id, dto) => {
  const { data } = await axios.put(`${baseUrl}/category/${id}`, dto);
  return data;
};

// 카테고리 순서 변경
const updateLdasCategoryOrder = async (dto) => {
  const { data } = await axios.put(`${baseUrl}/category/order`, dto);
  return data;
};

// 카테고리 삭제
const deleteLdasCategory = async (id) => {
  const { data } = await axios.delete(`${baseUrl}/category/${id}`);
  return data;
};

/**
 *
 * 로트 api
 */

// 제품별 Lot 목록 (page, size)
const readLdasLotListByProduct = async (
  productId,
  { page = 0, size = 5 } = {},
) => {
  const { data } = await axios.get(`${baseUrl}/lot/list/${productId}`, {
    params: { page, size },
  });
  console.log("readLdasLotListByProduct data", data);
  return data;
};

// Lot 상세
const readLdasLotDetail = async (id) => {
  const { data } = await axios.get(`${baseUrl}/lot/${id}`);
  return data;
};

// Lot 등록
const createLdasLot = async (dto) => {
  const { data } = await axios.post(`${baseUrl}/lot`, dto);
  return data;
};

// Lot 수정
const updateLdasLot = async (id, dto) => {
  const { data } = await axios.put(`${baseUrl}/lot/${id}`, dto);
  return data;
};

// Lot 삭제
const deleteLdasLot = async (id) => {
  const { data } = await axios.delete(`${baseUrl}/lot/${id}`);
  return data;
};

/**
 *
 * 테스트 리포트 api
 */

// Lot별 테스트 리포트 목록 조회
const readLdasTestReportListByLot = async (
  lotId,
  { page = 0, size = 5 } = {},
) => {
  const { data } = await axios.get(`${baseUrl}/testReport/list/${lotId}`, {
    params: { page, size },
  });
  // console.log("readLdasTestReportListByLot data", data);
  return data;
};

// 테스트 리포트 상세 조회
const readLdasTestReportDetail = async (id) => {
  const { data } = await axios.get(`${baseUrl}/testReport/${id}`);
  return data;
};

// 테스트 리포트 등록
const createLdasTestReport = async (dto) => {
  const { data } = await axios.post(`${baseUrl}/testReport`, dto);
  return data;
};

// 테스트 리포트 수정
const updateLdasTestReport = async (id, dto) => {
  const { data } = await axios.put(`${baseUrl}/testReport/${id}`, dto);
  return data;
};

// 테스트 리포트 삭제
const deleteLdasTestReport = async (id) => {
  const { data } = await axios.delete(`${baseUrl}/testReport/${id}`);
  return data;
};

/**
 *
 * 인증 api
 */

// Lot별 인증 목록 조회
const readLdasCertificationListByLot = async (
  lotId,
  { page = 0, size = 10 } = {},
) => {
  const { data } = await axios.get(`${baseUrl}/certification/list/${lotId}`, {
    params: { page, size },
  });
  return data;
};

// 인증 상세 조회
const readLdasCertificationDetail = async (id) => {
  const { data } = await axios.get(`${baseUrl}/certification/${id}`);
  return data;
};

// 인증 등록
const createLdasCertification = async (dto) => {
  const { data } = await axios.post(`${baseUrl}/certification`, dto);
  return data;
};

// 인증 수정
const updateLdasCertification = async (id, dto) => {
  const { data } = await axios.put(`${baseUrl}/certification/${id}`, dto);
  return data;
};

// 인증 삭제
const deleteLdasCertification = async (id) => {
  const { data } = await axios.delete(`${baseUrl}/certification/${id}`);
  return data;
};

const LdasApi = {
  readLdasProductList,
  readLdasProductDetail,
  createLdasProduct,
  updateLdasProduct,
  deleteLdasProduct,
  readLdasCategoryList,
  readLdasCategoryListByProduct,
  createLdasCategory,
  updateLdasCategory,
  updateLdasCategoryOrder,
  deleteLdasCategory,
  readLdasLotListByProduct,
  readLdasLotDetail,
  createLdasLot,
  updateLdasLot,
  deleteLdasLot,
  readLdasTestReportListByLot,
  readLdasTestReportDetail,
  createLdasTestReport,
  updateLdasTestReport,
  deleteLdasTestReport,
  readLdasCertificationListByLot,
  readLdasCertificationDetail,
  createLdasCertification,
  updateLdasCertification,
  deleteLdasCertification,
};

export default LdasApi;
